import React, { useCallback, useEffect, useState } from 'react';
import { Pagination, Modal, Tooltip } from '@roo/roo';
import { TableNew, Input, Button } from 'RooV1.12';
import request from '@/utils/request';
import DistributeList from '../distributeList';
import HistoryList from '../historyList';
import { ALIGN_TYPES } from '../../types';
import { getCookie } from '@utiljs/cookie';
import dayJs from 'dayjs';
import './index.scss';

const AllocatedTable: React.FC = () => {
    const [distributeStatus, setDistributeStatus] = useState('');

    // 门店列表
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [allocatedList, setAllocatedList] = useState<urls.distribute.StoreDetail[]>([]);
    const [bindWmPoiId, setBindWmPoiId] = useState(0);
    // 员工拥有门店数列表
    const [selectedStaff, setSelectedStaff] = useState('');
    const [staffOwnList, setStaffOwnList] = useState<urls.distribute.DistributedDetail[]>([]);

    // Modal展示
    const [operateVisible, setOperateVisible] = useState(false);
    const [checkVisible, setCheckVisible] = useState(false);
    // 搜索值
    const [searchValue, setSearchValue] = useState('');
    const companyName = decodeURIComponent(getCookie('serviceProviderName'));

    const handleBind = useCallback(status => {
        if (status) {
            setOperateVisible(false);
        }
    }, []);

    // 分配门店列表
    const columns = [
        {
            title: <span className="list-header">门店名称</span>,
            dataIndex: 'wmPoiName',
            width: 60,
            align: ALIGN_TYPES.LEFT,
            render(wmPoiName: any) {
                return <span className="list-content">{wmPoiName}</span>;
            },
        },
        {
            title: <span className="list-header">门店ID</span>,
            dataIndex: 'wmPoiId',
            width: 60,
            align: ALIGN_TYPES.LEFT,
            render(wmPoiId: any) {
                return <span className="list-content">{wmPoiId}</span>;
            },
        },
        {
            title: <span className="list-header">分配时间</span>,
            dataIndex: 'ctime',
            width: 60,
            align: ALIGN_TYPES.LEFT,
            render(ctime: any) {
                return (
                    <span className="list-content">{dayJs(ctime * 1000).format('YYYY-MM-DD')}</span>
                );
            },
        },
        {
            title: <span className="list-header">运营人</span>,
            width: 30,
            dataIndex: 'manager',
            align: ALIGN_TYPES.CENTER,
            render(manager: any) {
                return <span className="list-cotent">{manager}</span>;
            },
        },
        {
            title: <span className="list-header">操作</span>,
            dataIndex: 'operate',
            width: 40,
            align: ALIGN_TYPES.CENTER,
            render(operate: any, record: any) {
                return (
                    <span
                        className="list-cotent-operate"
                        onClick={() => {
                            setOperateVisible(true);
                            setBindWmPoiId(record.wmPoiId);
                        }}
                    >
                        重新分配
                    </span>
                );
            },
        },
        {
            title: <span className="list-header">历史运营人</span>,
            width: 30,
            align: ALIGN_TYPES.CENTER,
            dataIndex: 'history',
            render(history: any, record: any) {
                return (
                    <span
                        className="list-cotent-operate"
                        onClick={() => {
                            setCheckVisible(true);
                            setBindWmPoiId(record.wmPoiId);
                        }}
                    >
                        查看
                    </span>
                );
            },
        },
    ];

    // 获取已分配门店列表数据
    const getUnallocatedList = (searchVal?: string, staffAcctId?: number) => {
        const parms = {
            pageNum,
            pageSize,
            wmPoiId: searchVal !== null ? searchVal : '',
            staffAcctId: staffAcctId != null ? staffAcctId : selectedStaff,
        };
        request
            .get('/api/thirdpartnar/poi/distribution/processed/list', parms)
            .then((res: urls.serverBase<urls.distribute.UnallocatedList>) => {
                if (res.data) {
                    const { list, total } = res.data;
                    setTotal(total);
                    setAllocatedList(list);
                }
            })
            .catch(error => {
                console.error(error);
            });
    };

    useEffect(() => {
        getUnallocatedList();
    }, [pageNum, pageSize, distributeStatus]);

    // 获取员工分配门店数
    const getStaffOwns = () => {
        request
            .get('/api/thirdpartnar/poi/distribution/staff/distributed/nums', {})
            .then(res => {
                const initailOwnList: urls.distribute.DistributedDetail[] = res.data;
                setStaffOwnList(initailOwnList);
            })
            .catch(error => {
                console.error(error);
            });
    };
    useEffect(() => {
        getStaffOwns();
    }, [distributeStatus]);

    // 员工分配门店列表
    const StaffDistributedList = ({ items, selectedId }) => {
        return (
            <div className="staff-list-content">
                {items.map(item => (
                    <Tooltip content={item.staffAcctLogin} trigger="hover" effect="light">
                        <div
                            key={item.staffAcctId}
                            onClick={() => onSelect(item.staffAcctId)}
                            className={`staff-list-item ${
                                item.staffAcctId === selectedId ? 'staff-list-item-selected' : ''
                            }`}
                        >
                            <span className="item-text">
                                {item.staffName} ({item.num}家)
                            </span>
                        </div>
                    </Tooltip>
                ))}
            </div>
        );
    };

    const onSelect = staffAcctId => {
        setSelectedStaff(staffAcctId);
        getUnallocatedList(undefined, staffAcctId);
    };

    return (
        <div className="alocated-store">
            <div className="alocated-header">
                <span className="header-title">
                    {companyName} ({allocatedList.length}家)
                </span>
                <span>
                    <Input
                        className="input-search"
                        size="normal"
                        styleType="plaintext"
                        placeholder="请输入门店ID"
                        onPressEnter={() => {
                            getUnallocatedList(searchValue);
                        }}
                        onChange={e => {
                            setSearchValue(e.target.value);
                        }}
                    />
                    <Button
                        className="search-confirm"
                        onClick={() => {
                            getUnallocatedList(searchValue);
                        }}
                    >
                        搜索
                    </Button>
                </span>
            </div>
            <div className="alocated-content">
                <div className="staff-list">
                    <StaffDistributedList items={staffOwnList} selectedId={selectedStaff} />
                </div>
                <div className="alocated-list">
                    <TableNew columns={columns} data={allocatedList} bordered />
                    <div className="pagination-right">
                        <Pagination
                            total={total}
                            currentPage={pageNum}
                            pageSize={pageSize}
                            onChange={pageNum => setPageNum(pageNum)}
                        />
                    </div>
                    <Modal
                        title={'重新绑定运营人'}
                        visible={operateVisible}
                        onCancel={() => {
                            setOperateVisible(false);
                        }}
                        showCancelButton={false}
                        showConfirmButton={false}
                        size="lg"
                    >
                        {operateVisible && (
                            <DistributeList
                                type="redistribute"
                                handleBind={handleBind}
                                wmPoiId={bindWmPoiId}
                                setDistributeStatus={setDistributeStatus}
                            />
                        )}
                    </Modal>
                    <Modal
                        title={'历史运营人'}
                        visible={checkVisible}
                        onCancel={() => {
                            setCheckVisible(false);
                        }}
                        showCancelButton={false}
                        showConfirmButton={false}
                        size="lg"
                    >
                        {checkVisible && <HistoryList wmPoiId={bindWmPoiId} />}
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default AllocatedTable;
